import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum FiscalizationTypeId {
  EET = 1,
  HUNGARY = 3,
  POLAND = 4,
  EKASA = 5,
  FISKAL_TRUST = 6,
  ROMANIA = 7,
  KSEF_PL = 8,
  BSX_PRINTER = 9,
}

export class FiscalizationType extends Codebook<FiscalizationTypeId> {
  static readonly EET = new FiscalizationType(FiscalizationTypeId.EET, () => $t('EET'))
  static readonly HUNGARY = new FiscalizationType(FiscalizationTypeId.HUNGARY, () => $t('Hungary'))
  static readonly POLAND = new FiscalizationType(FiscalizationTypeId.POLAND, () => $t('Poland'))
  static readonly EKASA = new FiscalizationType(FiscalizationTypeId.EKASA, () => $t('eKasa'))
  static readonly FISKAL_TRUST = new FiscalizationType(FiscalizationTypeId.FISKAL_TRUST, () =>
    $t('FiskalTrust'),
  )
  static readonly ROMANIA = new FiscalizationType(FiscalizationTypeId.ROMANIA, () => $t('Romania'))
  static readonly KSEF_PL = new FiscalizationType(FiscalizationTypeId.KSEF_PL, () => $t('KSeF'))
  static readonly BSX_PRINTER = new FiscalizationType(FiscalizationTypeId.BSX_PRINTER, () =>
    $t('BSX printer'),
  )

  private constructor(
    public readonly id: FiscalizationTypeId,
    public readonly label: () => string,
  ) {
    super(id)
  }
}
